import { apiCallWrapper, EntitiesPaginatedModel, SelectOptionModel } from 'traveldesk-ui'
import { ExternalTourSelectOptionModel, TourImportCacheFileModel, TourImportCacheModel, TourImportModel } from '../pages/TourImport/TourImportModel'
import { keysToCamelCase } from '../utils/keysToCamelCase'
export interface ApiIntegrationOption extends SelectOptionModel {
    availabilityRequestLimitDays: number | undefined
}
export interface ExternalToursFilterModel {
    page?: number
    onPage?: number
    cityId?: string
    countryId?: string
    categoryId?: string
}
export interface ExternalToursPaginatedFilterModel {
    apiIntegrationId: number
    page: number
    cityId?: string
    countryId?: string
    categoryId?: string
}
export default class ExternalIntegrationsApiService {
    public static async updateTourCache(dispatch: any,apiIntegrationId: string, externalId: string) {
        return await apiCallWrapper<TourImportCacheModel>(`/api/externalintegrations/tours/cache/update/${apiIntegrationId}/${externalId}`, 'GET', dispatch)
    }
    public static async syncTour(dispatch: any, externalId: string) {
        return await apiCallWrapper<void>('/api/externalintegrations/tours/sync/' + externalId, 'GET', dispatch)
    }
    public static async cacheAllTours(dispatch: any, apiIntegrationId: string) {
        return await apiCallWrapper<void>('/api/externalintegrations/tours/cache/' + apiIntegrationId, 'GET', dispatch)
    }
    public static async getApiIntegrations(dispatch: any) {
        return await apiCallWrapper<ApiIntegrationOption[]>('/api/externalintegrations', 'GET', dispatch)
    }    
    public static async getExternalTours(dispatch: any, apiIntegrationId: string, filter: ExternalToursFilterModel = {}) {
        const query = new URLSearchParams()
        query.set('apiProviderId', apiIntegrationId)
        if (filter.page != null) {
            query.set('page', filter.page.toString())
        }
        if (filter.onPage != null) {
            query.set('onPage', filter.onPage.toString())
        }
        if (filter.cityId) {
            query.set('cityId', filter.cityId)
        }
        if (filter.countryId) {
            query.set('countryId', filter.countryId)
        }
        if (filter.categoryId) {
            query.set('categoryId', filter.categoryId)
        }
        return await apiCallWrapper<EntitiesPaginatedModel<ExternalTourSelectOptionModel>>(`/api/externalintegrations/tours?${query.toString()}`, 'GET', dispatch)
    }
    public static async getExternalToursPaginated(dispatch: any, filter: ExternalToursPaginatedFilterModel) {
        return await apiCallWrapper<EntitiesPaginatedModel<TourImportCacheFileModel>>('/api/externalintegrations/tours/paginaged', 'POST', dispatch, filter)
    }
    public static async getExternalTourCache(cacheFileUrl: string, allowDiskCache: boolean = false): Promise<TourImportCacheModel | undefined> {
        try {
            const params = {

            }
            if(!allowDiskCache){
                (params as any).cache = 'no-store'
            }
            const response = await fetch(cacheFileUrl, params)
            if (!response.ok) {
                return undefined
            }
            const parsed = keysToCamelCase(await response.json()) as TourImportCacheModel
            return Object.assign(new TourImportCacheModel(), parsed, {
                fileName: cacheFileUrl,
                isLoading: false,
                tourImportModel: parsed.tourImportModel ? TourImportModel.Create(parsed.tourImportModel) : undefined,
            })
        } catch {
            return undefined
        }
    }
    public static async getExternalTour(dispatch: any, tourId: string, apiIntegrationId: string, availabilityRequestLimitDays?: number) {
        const limitParam = availabilityRequestLimitDays != null ? `&availabilityRequestLimitDays=${availabilityRequestLimitDays}` : ''
        return await apiCallWrapper<TourImportModel>(`/api/externalintegrations/tours/${tourId}?apiProviderId=${apiIntegrationId}${limitParam}`, 'GET', dispatch)
    }
    public static async getExternalCountries(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<SelectOptionModel[]>('/api/externalintegrations/countries?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async getExternalCategoriesMappings(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCategoryMappingModel[]>('/api/externalintegrations/categories?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async getExternalCategories(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCategoryMappingModel[]>('/api/externalintegrations/categories?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async saveExternalCategoriesMapping(dispatch: any, category: ExternalCategoryMappingPostModel) {
        return await apiCallWrapper<ExternalCategoryMappingModel>('/api/externalintegrations/categories', 'POST', dispatch, category)
    }
    public static async getExternalCitiesMappings(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCityMappingModel[]>('/api/externalintegrations/cities?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async getExternalCities(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCityMappingModel[]>('/api/externalintegrations/cities?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async saveExternalCitiesMapping(dispatch: any, city: ExternalCityMappingPostModel) {
        return await apiCallWrapper<ExternalCityMappingModel>('/api/externalintegrations/cities', 'POST', dispatch, city)
    }
}
export interface ExternalTourMappingModel {
    externalId: string
    tourId: number
}
export interface ExternalCityMappingModel {
    apiIntegrationCityId: string
    apiIntegrationCityName: string
    ourCityId: number
}
export interface ExternalCategoryMappingModel {
    apiIntegrationCategoryId: string
    apiIntegrationCategoryName: string
    ourCategoryId: number
}
export interface ExternalCategoryMappingPostModel {
    apiProviderId: number
    categoryId: number
    externalCategoryId: string
}
export interface ExternalCityMappingPostModel {
    apiProviderId: number
    cityId: number
    externalCityId: string
}